import { ChildStatus, LabelMapper } from 'types';

export const childStatusesLabels: LabelMapper<ChildStatus> = {
    ACTIVE: 'Aktywny',
    INACTIVE: 'Nieaktywny',
};
